/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sex: NonNullable<unknown>, age: NonNullable<unknown>, weightText: NonNullable<unknown> }} Exercise_Personal_Strength_BasisInputs */

const en_us2_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} years, ${i?.weightText}`)
};

const pt_br2_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} anos, ${i?.weightText}`)
};

const es_419_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} años, ${i?.weightText}`)
};

const pt_pt2_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} anos, ${i?.weightText}`)
};

const fr_fr2_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} ans, ${i?.weightText}`)
};

const de_de2_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} Jahre, ${i?.weightText}`)
};

const it_it2_exercise_personal_strength_basis = /** @type {(inputs: Exercise_Personal_Strength_BasisInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sex}, ${i?.age} anni, ${i?.weightText}`)
};

/**
* | output |
* | --- |
* | "{sex}, {age} years, {weightText}" |
*
* @param {Exercise_Personal_Strength_BasisInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_basis = /** @type {((inputs: Exercise_Personal_Strength_BasisInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_BasisInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_basis(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_basis(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_basis(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_basis(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_basis(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_basis(inputs)
	return en_us2_exercise_personal_strength_basis(inputs)
});
export { exercise_personal_strength_basis as "exercise-personal.strength_basis" }